import i18next from "i18next";
import React, { useContext } from "react";
import { Dropdown, Row } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { useTranslation } from "react-i18next";
import { StyledLink, StyledNavbar } from "./AppNavbar.styles";
import { AuthContext } from "../../context/AuthContext";
import { useHistory } from "react-router-dom";
import evoliLogo from "../../assets/images/evoli.png";
import evoliLogoWhite from "../../assets/images/evoliWhite.png";

/* Application navbar. It contains the links to the current accessible pages, such as about page, home page, index page and
also a logout button if the user is logged.*/
const AppNavbar = (props) => {
  return (
    <StyledNavbar expand="md" dark={props.dark} sticky={props.sticky ? "top" : ""}>
      <StyledLink to="/" className="text-uppercase">
        <Navbar.Brand>
          <img src={props.dark ? evoliLogoWhite : evoliLogo} alt="EVOLI" />
        </Navbar.Brand>
      </StyledLink>
      <Navbar.Toggle aria-controls="navbar-content" />
      <Navbar.Collapse id="navbar-content" className="justify-content-end">
        <Nav>
          <Row className="me-2">{props.startButtons}</Row>
          <LanguageChooser />
          <ProfileButton />
        </Nav>
      </Navbar.Collapse>
    </StyledNavbar>
  );
};

const ProfileButton = () => {
  const { t } = useTranslation("", { keyPrefix: "components.navbar" });
  const history = useHistory();
  const { currentUser } = useContext(AuthContext);

  return currentUser ? (
    <StyledLink className="nav-item nav-link" to="#" onClick={() => history.push("/profile")}>
      <i className="fas fa-user pe-2" />
    </StyledLink>
  ) : (
    <StyledLink className="nav-item nav-link" to="/login">
      {t("login")}
    </StyledLink>
  );
};

const LanguageChooser = () => {
  const languages = {
    it: "Italiano",
    en: "English",
  };

  return (
    <Dropdown className="text-capitalize nav-item nav-link">
      <Dropdown.Toggle as={CustomToggle}></Dropdown.Toggle>
      <Dropdown.Menu>
        {Object.entries(languages).map(([id, name]) => (
          <Dropdown.Item key={id} onClick={() => i18next.changeLanguage(id)}>
            {name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

// The forwardRef is important!!
// Dropdown needs access to the DOM node in order to position the Menu
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <i
    className="fas fa-globe fa-lg"
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
    <span className="fs-5 mx-1 fw-lighter">&#11167;</span>
  </i>
));

export default AppNavbar;
